import { env } from './env';

export const INITIAL_TABLE_PAGE_COUNT = 1;

// 管理画面の一覧で選べる1ページの件数と、初期表示の件数
export const TABLE_ROWS_PER_PAGE_OPTIONS = [20, 50, 100];

export const DEFAULT_TABLE_ROWS_PER_PAGE = 50;

export const BASE_URL = env('REACT_APP_API_URL');

export const MASTER_BASE_URL = env('REACT_APP_MASTER_API_URL');

export const USER_BASE_URL = env('REACT_APP_USER_API_URL');

export const USER_PAGE_URL = env('REACT_APP_USER_PAGE_URL');

export const USER_CSV_TEMPLATE_URL = env('REACT_APP_USER_CSV_TEMPLATE_URL');

/**
 * 管理者のトークンを HttpOnly の Cookie だけで受け渡すか (既定は false)
 *
 * - false: これまでどおりログインで受け取ったトークンを localStorage に保存し、Authorization: Bearer で送る
 * - true: トークンを保存も送信もせず、API が発行する Cookie (__Host-uzone_{env}_admin_token) で認証する。
 *   ログイン中かどうかは起動時に認証の要る API を呼んで決める (lib/auth.jsx)
 *
 * true にするのは、向き先の API で AUTH_COOKIE_ENABLED=true にした後だけ
 * (API が Cookie を発行しないとログインできない)
 */
export const AUTH_COOKIE_ONLY = env('REACT_APP_AUTH_COOKIE_ONLY') === 'true';

export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  // Laravel の CSRF トークン切れ・セッション切れ
  PAGE_EXPIRED: 419,
  UNPROCESSABLE_ENTITY: 422,
  INTERNAL_SERVER_ERROR: 500,
};

export const MAX_ITEM_IMAGE_SIZE_BYTES = 5 * 1024 * 1024;

/**
 * 外部管理者の操作スコープ
 * - PRODUCTS: 商品系のみ操作可（既存カイショー相当）
 * - ORDERS: 注文一覧・注文詳細のみ操作可（一城向け）
 * @todo Phase2: 権限テーブル対応後、role ベースに変更
 */
export const EXTERNAL_ADMIN_SCOPE = {
  PRODUCTS: 'products',
  ORDERS: 'orders',
  BUYER: 'buyer',
};

export const PREFECTURE_LIST = [
  { value: 1, label: '北海道' },
  { value: 2, label: '青森県' },
  { value: 3, label: '岩手県' },
  { value: 4, label: '宮城県' },
  { value: 5, label: '秋田県' },
  { value: 6, label: '山形県' },
  { value: 7, label: '福島県' },
  { value: 8, label: '茨城県' },
  { value: 9, label: '栃木県' },
  { value: 10, label: '群馬県' },
  { value: 11, label: '埼玉県' },
  { value: 12, label: '千葉県' },
  { value: 13, label: '東京都' },
  { value: 14, label: '神奈川県' },
  { value: 15, label: '新潟県' },
  { value: 16, label: '富山県' },
  { value: 17, label: '石川県' },
  { value: 18, label: '福井県' },
  { value: 19, label: '山梨県' },
  { value: 20, label: '長野県' },
  { value: 21, label: '岐阜県' },
  { value: 22, label: '静岡県' },
  { value: 23, label: '愛知県' },
  { value: 24, label: '三重県' },
  { value: 25, label: '滋賀県' },
  { value: 26, label: '京都府' },
  { value: 27, label: '大阪府' },
  { value: 28, label: '兵庫県' },
  { value: 29, label: '奈良県' },
  { value: 30, label: '和歌山県' },
  { value: 31, label: '鳥取県' },
  { value: 32, label: '島根県' },
  { value: 33, label: '岡山県' },
  { value: 34, label: '広島県' },
  { value: 35, label: '山口県' },
  { value: 36, label: '徳島県' },
  { value: 37, label: '香川県' },
  { value: 38, label: '愛媛県' },
  { value: 39, label: '高知県' },
  { value: 40, label: '福岡県' },
  { value: 41, label: '佐賀県' },
  { value: 42, label: '長崎県' },
  { value: 43, label: '熊本県' },
  { value: 44, label: '大分県' },
  { value: 45, label: '宮崎県' },
  { value: 46, label: '鹿児島県' },
  { value: 47, label: '沖縄県' },
];

const USER_STATUS_MAP = {
  INACTIVE: { value: 0, label: '利用停止' },
  ACTIVE: { value: 1, label: '有効' },
  EMAIL_PENDING: { value: 2, label: 'メール認証中' },
  APPROVAL_PENDING: { value: 3, label: '管理者承認待ち' },
};

export const USER_STATUS = Object.fromEntries(
  Object.entries(USER_STATUS_MAP).map(([k, v]) => [k, v.value]),
);

export const USER_STATUS_LIST = Object.values(USER_STATUS_MAP);

export const USER_STATUS_DEFAULTS = [
  USER_STATUS.ACTIVE,
  USER_STATUS.EMAIL_PENDING,
  USER_STATUS.APPROVAL_PENDING,
];

export const getUserStatusLabel = (value) =>
  Object.values(USER_STATUS_MAP).find((s) => s.value === value)?.label ?? '';

export const DELIVERY_COMPANY = [
  { value: 1, label: 'クロネコヤマト' },
  { value: 2, label: '佐川急便' },
  { value: 3, label: 'ゆうパック' },
  { value: 4, label: '西濃運輸' },
  { value: 5, label: '福山通運' },
  { value: 6, label: '第一貨物' },
  { value: 7, label: '久留米運送' },
  { value: 8, label: 'トールエクスプレス' },
  { value: 9, label: 'セイノースーパーエクスプレス' },
  { value: 10, label: 'ヤマト以外' },
];

export const CUTOFF_TIME = [
  { value: 1, label: '1時' },
  { value: 2, label: '2時' },
  { value: 3, label: '3時' },
  { value: 4, label: '4時' },
  { value: 5, label: '5時' },
  { value: 6, label: '6時' },
  { value: 7, label: '7時' },
  { value: 8, label: '8時' },
  { value: 9, label: '9時' },
  { value: 10, label: '10時' },
  { value: 11, label: '11時' },
  { value: 12, label: '12時' },
  { value: 13, label: '13時' },
  { value: 14, label: '14時' },
  { value: 15, label: '15時' },
  { value: 16, label: '16時' },
  { value: 17, label: '17時' },
  { value: 18, label: '18時' },
  { value: 19, label: '19時' },
  { value: 20, label: '20時' },
  { value: 21, label: '21時' },
  { value: 22, label: '22時' },
  { value: 23, label: '23時' },
  { value: 24, label: '24時' },
];

export const MYSQL_CONST = {
  SIGNED_INT: 2147483647,
};
